export default "__VITE_ASSET__BAowlpuv__"